import { TamaguiProvider, View } from "@tamagui/core";
import tamaguiConfig from "@/ui/theme/tamagui.config";
import { ColorToken, ColorTokenValues } from "@/ui/theme/tokens";

import type { Preview } from "@storybook/react";
import { ScrollView } from "react-native";

const preview: Preview = {
  decorators: [
    (Story) => (
      <TamaguiProvider config={tamaguiConfig} defaultTheme="light">
        <ScrollView
          contentContainerStyle={{ height: "100%" }}
          style={{ backgroundColor: ColorTokenValues[ColorToken.NeutralBackgroundPrimary] }}
        >
          <View
            alignItems="center"
            flex={1}
            padding={20}
            width="100%"
          >
            <Story />
          </View>
        </ScrollView>
      </TamaguiProvider>
    ),
  ],
  parameters: {
    controls: {
      matchers: {
        color: /(background|color)$/i,
        date: /Date$/,
      },
    },
  },
};

export default preview;
